<div class="row align-items-end mt-3">
  <div class="col-6 col-lg-8">
    <button
      *ngIf="!isFirstStep"
      type="button"
      class="btn btn-outline-primary btn-sm checkout-btn-previous checkout-btn"
      (click)="prevClicked.emit()"
      translate
    >
      {{ prevBtnText }}
    </button>
  </div>

  <div class="col-6 col-lg-4">
    <div class="row d-flex justify-content-end align-items-end">
      <div class="col-12 col-md-6">
        <button
          class="btn btn-primary w-100 btn-sm checkout-btn-next checkout-btn ml-auto"
          type="button"
          (click)="nextClicked.emit()"
        >
          <span translate>{{ nextBtnText }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
